import { StudentListSectionCombinedProps } from './types';

const usePresenter = (props: StudentListSectionCombinedProps): StudentListSectionCombinedProps => {
  return props;
};

export default usePresenter;
